import { GfAdminUserDto } from "@swagger/typescript-fetch-goflyer";
import { toastError } from "../utils/pageUtil/toast";
import { messages } from "../locales/messages";
import { adminApiService } from "../utils/api";
import i18n from "i18next";
import { useLoading } from "../contextApi/LoadingContext";
import { useAuthHeaders } from "./useAuthHeaders";

export const useHandleSubscription = () => {
  const { showLoadingScreen } = useLoading();
  const authHeaders = useAuthHeaders();

  const handleUpdateSubscription = async (
    plain?: string
  ): Promise<GfAdminUserDto | null> => {
    try {
      if (plain === undefined || plain === null) {
        return null;
      }
      showLoadingScreen(true);

      const adminUser =
        await adminApiService.gfAdminUserAdminControllerUpdateAdminSubscription(
          plain,
          authHeaders
        );
      showLoadingScreen(false);

      return adminUser;
    } catch (error) {
      showLoadingScreen(false);

      const errorMessage = `${i18n.t(
        messages.There_is_an_error_please_Contact_Administrator()
      )}`;
      toastError(errorMessage);

      console.error("Error saving onboarding store:", error);
      return null;
    }
  };

  return handleUpdateSubscription;
};
